$("[data-fancybox]").fancybox({
    animationEffect: "fade"
});

$('.single-item').slick({
    autoplay: true,
    dots: true,
    arrows: true,
    infinite: false,
    responsive: [
        {
            breakpoint: 992,
            settings: {
                arrows: false,
            }
        }
    ]
});

$('.projects-and-partners-carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: true,
    arrows: false,
    infinite: false
});

$('.news-gallery').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: true
});

// $('.widgets').slick({
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     autoplay: false,
//     infinite: false,
//     dots: false,
//     arrows: true
// });
//---------------------------------------------style switcher--------------------------------------------------------------//
var stylesheets = [
    [ 'fonts-normal', 'fonts-bigger', 'fonts-biggest' ],
    [ 'colors-normal', 'colors-inverse', 'colors-comfort', 'colors-contrast' ],
    [ 'img-on', 'img-off' ]
];

function getStylesheetsGroup(key) {
    for (var i =0; i < stylesheets.length; i++) {
        var stylesheetGroup = stylesheets[i];
        if (stylesheetGroup.indexOf(key) !== -1) {
            return stylesheetGroup;
        }
    }
    return [];
}

function saveStyleKey(key) {
    var newStyles = [];
    var savedStyles = localStorage.getItem('siteMode').split('|');
    var groupForSavingStyle = getStylesheetsGroup(key);
    for (var i = 0; i < savedStyles.length; i++) {
        var savedStyle = savedStyles[i];
        if (groupForSavingStyle.indexOf(savedStyle) === -1) {
            newStyles.push(savedStyle);
        }
    }
    newStyles.push(key);
    console.log(newStyles);
    localStorage.setItem('siteMode', newStyles.join('|'));
}

function setStylesheet(key) {
    var bodyTag = document.getElementsByTagName("body")[0];
    var groupOfClasses = getStylesheetsGroup(key);
    for (var i = 0; i < groupOfClasses.length; i++) {
        var x = groupOfClasses[i];
        bodyTag.classList.toggle(x, x === key);
    }
}

function chooseStyle(key) {
    setStylesheet(key);
    saveStyleKey(key);
}

document.addEventListener("DOMContentLoaded", function() {
    if (localStorage.getItem('siteMode')) {
        var selectedStyles = localStorage.getItem('siteMode').split('|');
        for (var i = 0; i < selectedStyles.length; i++) {
            setStylesheet(selectedStyles[i]);
        }
    }
});

//-------------------------------------hover remove on mobile------------------
function hasTouch() {
    return 'ontouchstart' in document.documentElement
        || navigator.maxTouchPoints > 0
        || navigator.msMaxTouchPoints > 0;
}

if (hasTouch()) { // remove all :hover stylesheets
    try { // prevent exception on browsers not supporting DOM styleSheets properly
        for (var si in document.styleSheets) {
            var styleSheet = document.styleSheets[si];
            if (!styleSheet.rules) continue;

            for (var ri = styleSheet.rules.length - 1; ri >= 0; ri--) {
                if (!styleSheet.rules[ri].selectorText) continue;

                if (styleSheet.rules[ri].selectorText.match(':hover')) {
                    styleSheet.deleteRule(ri);
                }
            }
        }
    } catch (ex) {}
}
//---------------------------menu on mobile-------------------------------------------

var menuItem = $('.main-mobile-menu > li.dropdown-hover');

menuItem.click(function () {
    var el = $('.sub-menu', this);
    el.is(":visible") ? el.hide() : el.show();
});

$(document).mouseup(function(e) {
    $(".main-mobile-menu .sub-menu").each((index, container) => {
        if (!$(container).parent().is(e.target) && $(container).has(e.target).length === 0)
            $(container).hide();
    });
});

//----------------------------------------scroll-to-content-on-mobile------------------------------

$( document ).ready(function() {
    if ($(window).width() < 1024) {
        $("#page-content").animate({
            scrollTop: $("#scrollPointer").offset().top
        }, 1000)
    }
});







// WEBPACK FOOTER //
// ./Resources/Public/js/script.js